import apiClient from '@/services/axios'

export async function put(id, createUpdateGuestListItemCommand) {

  var response = await apiClient.put(process.env.VUE_APP_MARCOM_API_BASE_URL + `/admin/guest-list-items/${id}`, createUpdateGuestListItemCommand);
  if (response) {
    console.log(response);
    return response.data;
  }

  throw new Error('Unable to update a guest list item.')
}
